export const validateLocationSlugs = (...locations: (string | undefined)[]) => {
    for (const loc of locations) {
        if (loc && !loc.match(/^[\w-]+$/)) {
            return false;
        }
    }

    return true;
};
